import script from "./AaPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./AaPermissions.vue?vue&type=script&setup=true&lang=js"

import "./AaPermissions.vue?vue&type=style&index=0&id=d60f3dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d60f3dbe"]])

export default __exports__